/**
 * Generated by orval v8.4.0 🍺
 * Do not edit manually.
 * Medme Analytics Reports API
 * API для генерации PDF/XLSX отчетов по аналитике медицинских клиник.

Все отчеты генерируются асинхронно в фоновом режиме. 
После создания задачи вы получаете `jobId` (UUID), по которому можно отслеживать статус и скачать готовый файл.

**Типы отчетов:**
- Общие показатели
- KPI по записям
- Подтверждение записи
- Отмена записи
- Статистика по виджету
- Статистика по отзывам
- Статистика по источникам записей

 * OpenAPI spec version: 1.0.0
 */

import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseQueryOptions,
	UseQueryResult,
} from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"
import type { ErrorType } from "../../custom-http-client"

import { customFetch } from "../../custom-http-client"
import type {
	BadRequestResponse,
	DefaultErrorResponse,
	ForbiddenResponse,
	UnauthorizedResponse,
	UserBusinessesResponse,
	UserProfileResponse,
} from ".././types"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

export type HTTPStatusCode1xx = 100 | 101 | 102 | 103
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308
export type HTTPStatusCode4xx =
	| 400
	| 401
	| 402
	| 403
	| 404
	| 405
	| 406
	| 407
	| 408
	| 409
	| 410
	| 411
	| 412
	| 413
	| 414
	| 415
	| 416
	| 417
	| 418
	| 419
	| 420
	| 421
	| 422
	| 423
	| 424
	| 426
	| 428
	| 429
	| 431
	| 451
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511
export type HTTPStatusCodes =
	| HTTPStatusCode1xx
	| HTTPStatusCode2xx
	| HTTPStatusCode3xx
	| HTTPStatusCode4xx
	| HTTPStatusCode5xx

/**
 * Возвращает список всех бизнесов (клиник), к которым у пользователя есть доступ.

**Использование:**
- Для фильтров в UI (выбор бизнеса)
- Определение доступных данных для пользователя

**Авторизация:**
Из JWT токена извлекается user_id, по которому определяются доступные бизнесы.

 * @summary Получить доступные бизнесы пользователя
 */
export type UserGetUserBusinessesResponse200 = {
	data: UserBusinessesResponse
	status: 200
}

export type UserGetUserBusinessesResponse400 = {
	data: BadRequestResponse
	status: 400
}

export type UserGetUserBusinessesResponse401 = {
	data: UnauthorizedResponse
	status: 401
}

export type UserGetUserBusinessesResponse403 = {
	data: ForbiddenResponse
	status: 403
}

export type UserGetUserBusinessesResponseDefault = {
	data: DefaultErrorResponse
	status: Exclude<HTTPStatusCodes, 200 | 400 | 401 | 403>
}

export type UserGetUserBusinessesResponseSuccess =
	UserGetUserBusinessesResponse200 & {
		headers: Headers
	}
export type UserGetUserBusinessesResponseError = (
	| UserGetUserBusinessesResponse400
	| UserGetUserBusinessesResponse401
	| UserGetUserBusinessesResponse403
	| UserGetUserBusinessesResponseDefault
) & {
	headers: Headers
}

export type UserGetUserBusinessesResponse =
	| UserGetUserBusinessesResponseSuccess
	| UserGetUserBusinessesResponseError

export const getUserGetUserBusinessesUrl = () => {
	return `/api/v1/user/businesses`
}

export const UserGetUserBusinesses = async (
	options?: RequestInit,
): Promise<UserGetUserBusinessesResponse> => {
	return customFetch<UserGetUserBusinessesResponse>(
		getUserGetUserBusinessesUrl(),
		{
			...options,
			method: "GET",
		},
	)
}

export const getUserGetUserBusinessesQueryKey = () => {
	return [`/api/v1/user/businesses`] as const
}

export const getUserGetUserBusinessesQueryOptions = <
	TData = Awaited<ReturnType<typeof UserGetUserBusinesses>>,
	TError = ErrorType<
		| BadRequestResponse
		| UnauthorizedResponse
		| ForbiddenResponse
		| DefaultErrorResponse
	>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof UserGetUserBusinesses>>,
			TError,
			TData
		>
	>
	request?: SecondParameter<typeof customFetch>
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {}

	const queryKey = queryOptions?.queryKey ?? getUserGetUserBusinessesQueryKey()

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof UserGetUserBusinesses>>
	> = ({ signal }) => UserGetUserBusinesses({ signal, ...requestOptions })

	return {
		queryKey,
		queryFn,
		refetchOnMount: false,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof UserGetUserBusinesses>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserGetUserBusinessesQueryResult = NonNullable<
	Awaited<ReturnType<typeof UserGetUserBusinesses>>
>
export type UserGetUserBusinessesQueryError = ErrorType<
	| BadRequestResponse
	| UnauthorizedResponse
	| ForbiddenResponse
	| DefaultErrorResponse
>

export function useUserGetUserBusinesses<
	TData = Awaited<ReturnType<typeof UserGetUserBusinesses>>,
	TError = ErrorType<
		| BadRequestResponse
		| UnauthorizedResponse
		| ForbiddenResponse
		| DefaultErrorResponse
	>,
>(
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof UserGetUserBusinesses>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof UserGetUserBusinesses>>,
					TError,
					Awaited<ReturnType<typeof UserGetUserBusinesses>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useUserGetUserBusinesses<
	TData = Awaited<ReturnType<typeof UserGetUserBusinesses>>,
	TError = ErrorType<
		| BadRequestResponse
		| UnauthorizedResponse
		| ForbiddenResponse
		| DefaultErrorResponse
	>,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof UserGetUserBusinesses>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof UserGetUserBusinesses>>,
					TError,
					Awaited<ReturnType<typeof UserGetUserBusinesses>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useUserGetUserBusinesses<
	TData = Awaited<ReturnType<typeof UserGetUserBusinesses>>,
	TError = ErrorType<
		| BadRequestResponse
		| UnauthorizedResponse
		| ForbiddenResponse
		| DefaultErrorResponse
	>,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof UserGetUserBusinesses>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Получить доступные бизнесы пользователя
 */

export function useUserGetUserBusinesses<
	TData = Awaited<ReturnType<typeof UserGetUserBusinesses>>,
	TError = ErrorType<
		| BadRequestResponse
		| UnauthorizedResponse
		| ForbiddenResponse
		| DefaultErrorResponse
	>,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof UserGetUserBusinesses>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions = getUserGetUserBusinessesQueryOptions(options)

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> }

	return { ...query, queryKey: queryOptions.queryKey }
}

/**
 * Возвращает профиль текущего пользователя с основными данными.

**Авторизация:**
Из JWT токена извлекается user_id, по которому определяется профиль пользователя.

 * @summary Получить профиль пользователя
 */
export type UserGetUserProfileResponse200 = {
	data: UserProfileResponse
	status: 200
}

export type UserGetUserProfileResponse400 = {
	data: BadRequestResponse
	status: 400
}

export type UserGetUserProfileResponse401 = {
	data: UnauthorizedResponse
	status: 401
}

export type UserGetUserProfileResponse403 = {
	data: ForbiddenResponse
	status: 403
}

export type UserGetUserProfileResponseDefault = {
	data: DefaultErrorResponse
	status: Exclude<HTTPStatusCodes, 200 | 400 | 401 | 403>
}

export type UserGetUserProfileResponseSuccess =
	UserGetUserProfileResponse200 & {
		headers: Headers
	}
export type UserGetUserProfileResponseError = (
	| UserGetUserProfileResponse400
	| UserGetUserProfileResponse401
	| UserGetUserProfileResponse403
	| UserGetUserProfileResponseDefault
) & {
	headers: Headers
}

export type UserGetUserProfileResponse =
	| UserGetUserProfileResponseSuccess
	| UserGetUserProfileResponseError

export const getUserGetUserProfileUrl = () => {
	return `/api/v1/user`
}

export const UserGetUserProfile = async (
	options?: RequestInit,
): Promise<UserGetUserProfileResponse> => {
	return customFetch<UserGetUserProfileResponse>(getUserGetUserProfileUrl(), {
		...options,
		method: "GET",
	})
}

export const getUserGetUserProfileQueryKey = () => {
	return [`/api/v1/user`] as const
}

export const getUserGetUserProfileQueryOptions = <
	TData = Awaited<ReturnType<typeof UserGetUserProfile>>,
	TError = ErrorType<
		| BadRequestResponse
		| UnauthorizedResponse
		| ForbiddenResponse
		| DefaultErrorResponse
	>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof UserGetUserProfile>>,
			TError,
			TData
		>
	>
	request?: SecondParameter<typeof customFetch>
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {}

	const queryKey = queryOptions?.queryKey ?? getUserGetUserProfileQueryKey()

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof UserGetUserProfile>>
	> = ({ signal }) => UserGetUserProfile({ signal, ...requestOptions })

	return {
		queryKey,
		queryFn,
		refetchOnMount: false,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof UserGetUserProfile>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserGetUserProfileQueryResult = NonNullable<
	Awaited<ReturnType<typeof UserGetUserProfile>>
>
export type UserGetUserProfileQueryError = ErrorType<
	| BadRequestResponse
	| UnauthorizedResponse
	| ForbiddenResponse
	| DefaultErrorResponse
>

export function useUserGetUserProfile<
	TData = Awaited<ReturnType<typeof UserGetUserProfile>>,
	TError = ErrorType<
		| BadRequestResponse
		| UnauthorizedResponse
		| ForbiddenResponse
		| DefaultErrorResponse
	>,
>(
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof UserGetUserProfile>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof UserGetUserProfile>>,
					TError,
					Awaited<ReturnType<typeof UserGetUserProfile>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useUserGetUserProfile<
	TData = Awaited<ReturnType<typeof UserGetUserProfile>>,
	TError = ErrorType<
		| BadRequestResponse
		| UnauthorizedResponse
		| ForbiddenResponse
		| DefaultErrorResponse
	>,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof UserGetUserProfile>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof UserGetUserProfile>>,
					TError,
					Awaited<ReturnType<typeof UserGetUserProfile>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useUserGetUserProfile<
	TData = Awaited<ReturnType<typeof UserGetUserProfile>>,
	TError = ErrorType<
		| BadRequestResponse
		| UnauthorizedResponse
		| ForbiddenResponse
		| DefaultErrorResponse
	>,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof UserGetUserProfile>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Получить профиль пользователя
 */

export function useUserGetUserProfile<
	TData = Awaited<ReturnType<typeof UserGetUserProfile>>,
	TError = ErrorType<
		| BadRequestResponse
		| UnauthorizedResponse
		| ForbiddenResponse
		| DefaultErrorResponse
	>,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof UserGetUserProfile>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions = getUserGetUserProfileQueryOptions(options)

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> }

	return { ...query, queryKey: queryOptions.queryKey }
}
